<template>
  <a-row class="container-fluid container-wrap col-sm-12 col-xs-12">
    <a-col :span="1"></a-col>
    <a-col class="justify-content-center" :span="22">
      <div style="margin-top: 28px"></div>
      <div class="card-header pb-0 col-sm-12 d-flex">
        <div class="col-sm-12 col-xs-12">
          <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
            <h3 class="title">{{ $t('navbar_subscription_list') }}</h3>
            <h5 class="desc">거래처 구독내역을 관리 할 수 있습니다.</h5>
          </div>
        </div>
      </div>
      <div class="card-body px-0 pt-0 pb-2 table-with-search">
        <div class="search-filter-container table-info-filter">
          <div class="search-filter-row">
            <div class="search-filter-title">
              검색어
            </div>
            <div class="search-filter-content">
              <div class="mobile-wrap">
                <a-select
                    size="small"
                    style="width: 150px"
                    v-model:value="searchFilter.keyword.option"
                    @change="v => searchFilter.keyword.option = v"
                >
                  <a-select-option value="거래처명">
                    거래처명
                  </a-select-option>
                  <a-select-option value="제품코드">
                    제품코드
                  </a-select-option>
                </a-select>
                <a-input
                    size="small"
                    v-model:value="searchFilter.keyword.word"
                    @keyup.enter="async (event) => {
                      paginationData.currentPage = 1
                      await uiHandler.search();
                    }"
                    @focusin="e => searchFilter.keyword.word = ''"
                    :placeholder="$t('common_searchfilter_placeholder')"
                >
                  <template #prefix>
                    <i
                        class="fa-regular fa-magnifying-glass"
                    />
                  </template>
                </a-input>
              </div>
              <div class="mobile-wrap">
                <button
                    class="search-btn-filter"
                    @click="async (event) => {
                      paginationData.currentPage = 1
                      await uiHandler.search()
                    }"
                >
                  검색
                </button>
                <button
                    class="init-btn"
                    @click="event => {
                      searchFilter.keyword.option = '거래처명'
                      searchFilter.keyword.word = ''
                      searchFilter.deptName = ''
                      dateRanges = []
                      searchFilter.subscriptionStartDate = ''
                      searchFilter.subscriptionEndDate = ''
                      paginationData.currentPage = 1
                      searchFilter.selectedDateFilter = 'all'
                      searchFilter.sort = {parameter: 'validationDate', method: 'descend'}
                      uiHandler.search()
                    }"
                >
                  초기화
                </button>
              </div>
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-title">
              계약일
            </div>
            <div class="search-filter-content">
              <div class="date-filter-container-wrapper is-mobile-only">
                <div class="date-filter-container ">
                  <div
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                      @click="async (e) => {
                        searchFilter.selectedDateFilter = 'all'
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                  >
                    {{ $t('common_total') }}
                  </div>
                  <div
                      v-for="item in searchFilter.dateFilters.slice(0,1)"
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                      @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                  >
                    {{
                      item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                    }}
                  </div>
                </div>
                <div class="date-filter-container ">
                  <div
                      v-for="item in searchFilter.dateFilters.slice(1,3)"
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                      @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                  >
                    {{
                      item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                    }}
                  </div>
                </div>
                <div class="date-filter-container  " style="width: 100%;">
                  <div
                      v-for="item in searchFilter.dateFilters.slice(3,4)"
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                      style="width: 100%; border-bottom: 1px solid rgba(0, 0, 0, 0.15);"
                      @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                  >
                    {{
                      item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                    }}
                  </div>
                </div>
              </div>
              <div class="date-filter-container is-desktop-tablet">
                <div
                    class="date-filter-item"
                    :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                    @click="async (e) => {
                        searchFilter.selectedDateFilter = 'all'
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                >
                  {{ $t('common_total') }}
                </div>
                <div
                    v-for="item in searchFilter.dateFilters"
                    class="date-filter-item"
                    :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                    @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                >
                  {{
                    item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                  }}
                </div>
              </div>

              <div class="date-selector-container custom" v-if="searchFilter.selectedDateFilter === 'etc'">
                <a-range-picker
                    size="small"
                    :allowClear="false" :locale="locale" v-model:value="dateRanges"
                    @change="async (e) => {
                    searchFilter.selectedDateFilter = 'etc'
                    paginationData.currentPage = 1
                    await uiHandler.search()
                  }"
                    style="width: 250px;"/>
              </div>
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-title">
              구독상태
            </div>
            <div class="search-filter-content">
              <a-select
                  style="width: 150px; min-width: 100px"
                  v-model:value="searchFilter.status"
                  @change="(val) => uiHandler.search({status: val})"
                  size="small"
                  :options="statusList"
              />
            </div>
          </div>
        </div>
        <div class="col-xs-12 table-info-filter">
          <div class="total-div">
            <p>
              {{ $t('common_total') }}
              <span class="number-highlight">{{ formatCommaNumber(subscription.totalDocs) }}</span>
              {{ $t('common_case') }}
            </p>
          </div>
          <div class="search-container">
            <a-select class="search-select" v-model:value="paginationData.rowsPerPage" style="width: 120px"
                      @change="uiHandler.search">
              <a-select-option :value="10" selected>10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
              <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
              <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="card content-wrap-card col-sm-12 col-xs-12 tableCard p-0">
          <div class="table-responsive table-wrap table-relative">
            <div class="table-spinner-container" v-if="dataLoading">
                <div class="spinner" />
            </div>
            <a-table class="ant-table-striped"
                     size="small"
                     bordered
                     :scroll="{ x: '2200px' }"
                     :columns="subscription.columns"
                     :data-source="subscription.list"
                     :pagination="false"
                     :showSorterTooltip="false"
                     @change="uiHandler.handleTableChange"
                     v-show="!dataLoading && subscription.list.length > 0"
            >
            </a-table>

            <div class="no-result-container" v-show="!dataLoading &&subscription.list.length ===  0">
                <i class="fa-solid fa-exclamation-triangle" />
                <span v-if="!dataLoading">{{ computedNoResultMessage }} </span>
            </div>
          </div>
        </div>
      </div>
      <pagination
          v-if="!noResult"
          :page-info="paginationData"
          page-name="SubscriptionList"
          @change-page="async (childPassParam) => {
            paginationData.currentPage = childPassParam.page;
            await uiHandler.search()
          }"
      />
    </a-col>
    <a-col :span="1"></a-col>
  </a-row>

  <!--  모달-->
  <subscrtiption-detail-modal
      :data-source="selectedPayments"
      :show-modal="modal.subscription.show"
      @close-modal="uiHandler.handleModal.subscriptionDetail.close"
  />
  <card-management-modal
      :data-source="selectedCards"
      :show-modal="modal.cardManagement.show"
      :client-name="selectedRowClientName"
      :product-name="selectedRowBarcode"
      @close-modal="uiHandler.handleModal.cardManagement.close"
      @reload="uiHandler.handleModal.cardManagement.reload"
  />
</template>
<script>
import { getProfile } from '@/utils/tokenStore';
import {defineComponent} from "vue";
import Pagination from "@/views/components/Pagination.vue";
import NoResult from "@/views/components/NoResult.vue";
import { canOpen } from '@/router';

const ACTILINK_CONTRACT_PATH = "/contract/actilink-rental/2c618b40-f56b-11ee-9b10-33ac85a1d5c7";
import subscriptionApi from "@/views/SubscriptionManagement/plasmapp/api";
import dayjs from "dayjs";
import 'dayjs/locale/ko'
import locale from "ant-design-vue/es/date-picker/locale/ko_KR";
import {dateUtils, formatCommaNumber, logging, oneBtnDialog, twoBtnDialog} from "@/utils/utils";
import {styles} from "@/views/ContractManagement/styles";
import SubscrtiptionDetailModal from "@/views/SubscriptionManagement/plasmapp/SubscrtiptionDetailModal.vue";
import CardManagementModal from "@/views/SubscriptionManagement/plasmapp/CardManagementModal.vue";
import {SubscriptionCardStatusEnum} from "@/views/SubscriptionManagement/plasmapp/subscriptionCardStatusEnum";

export default defineComponent({
  components: {
    CardManagementModal,
    SubscrtiptionDetailModal,
    Pagination,
    NoResult,
  },
  async mounted() {
    await this.uiHandler.init();
  },
  computed: {
    computedNoResultMessage() {
      if(this.calledApiTimes <= 1) {
        return this.$i18n.t('noresult_sub');
      } else {
        return this.$i18n.t('noresult_search');
      }
    },
    noResult() {
      return !this.$store.state.isLoading && this.subscription.totalDocs === 0
    },
    statusList() {
      return [
        {label: '전체', value: '전체'},
        {label: '정상', value: '정상'},
        {label: '일시납', value: '일시납'},
        {label: '미납', value: '미납'},
      ]
    }
  },
  data() {
    return {
      calledApiTimes: 0,
      uiHandler: this.ui(),
      apiHandler: this.api(),
      locale,
      dataLoading: false,
      formatCommaNumber,
      dateUtil: dateUtils(),
      companyInfo: JSON.parse(getProfile('CompanyInfo')),
      dateRanges: [dayjs().startOf('month'), dayjs()],
      selectedRowClientName: "",
      selectedRowBarcode: "",
      modal: {
        subscription: {
          show: false
        },
        cardManagement: {
          show: false
        },
      },
      searchFilter: {
        keyword: {
          option: '거래처명',
          word: ''
        },
        status: '전체',
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 'etc'],
        startContractDate: '',
        endContractDate: '',
        sort: {
            parameter: 'validationDate',
            method: 'descend'
        }
      },
      paginationData: {
        listSize: 0,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 1,
      },
      selectedPayments: [],
      selectedCards: [],
      subscription: {
        totalDocs: 0,
        list: [],
        columns: [
          {key: 'index', title: '번호', dataIndex: 'index', align: 'center', fixed: 'left', width: '40px'},
          {
            key: 'status', title: '상태', dataIndex: 'status', align: 'center', fixed: 'left', width: '80px',
            customRender: ({text, record}) => {
              let statusColor;
              if (record.status === '정상') {
                statusColor = styles.tags.green
              } else if (record.status === '계약생성대기') {
                statusColor = styles.tags.blue
              } else {
                statusColor = styles.tags.red
              }
              return (
                  <div style="display: flex; justify-content: center">
                    {record.status ?
                        <a-tag style={{...styles.tags.statusTag, ...statusColor}}>
                          <span style={{fontSize: '14px'}}>{record.status}</span>
                        </a-tag> : <span>-</span>
                    }
                  </div>
              )
            }
          },
          // {
          //   title: '결제정보',
          //   children: [
          //
          //   ]
          // },
          // {
          //   title: '계약정보',
          //   children: [
          //
          //   ]
          // },
          {
            key: 'clientName',
            title: '거래처명',
            dataIndex: 'clientName',
            align: 'center',
            fixed: 'left',
            width: '240px'
          },
          {
            key: 'clientManagerName',
            title: '거래처담당자',
            dataIndex: 'clientManagerName',
            align: 'center',
            fixed: 'left',
            width: '100px',
            customRender: ({text, record}) => {
              if (record.contractInfo) {
                const client = JSON.parse(record.contractInfo.metadatas.find(m => m.key === 'client').value)
                let clientManager = client ? client.manager : '-';
                let mobile = client ? client.mobile : '-';
                let email = client ? client.email : '-';
                let managerInfo = this.uiHandler.getManagerInfo(client);
                return (
                    <div>
                      <div style={{...styles.manager.name}}>
                        {clientManager}
                      </div>
                      <a-tooltip placement="top" title={
                        <div>
                          <span style={{...styles.manager.desc}}>모바일: </span>
                          <a-typography-text style={{...styles.manager.desc}}
                                             copyable> {mobile} </a-typography-text>
                          <br/>
                          <span style={{...styles.manager.desc}}>이메일: </span>
                          <a-typography-text style={{...styles.manager.desc}} copyable> {email} </a-typography-text>
                        </div>
                      }>
                        <a-typography-text ellipsis style={{width: '90px', cursor: "pointer"}}>
                          <span style={{...styles.manager.desc}}> {managerInfo} </span>
                        </a-typography-text>
                      </a-tooltip>
                    </div>
                )
              } else {
                return text
              }
            }
          },
          {
            key: 'clientEmail', title: '거래처 이메일', dataIndex: 'clientEmail', align: 'center', width: '160px',
            customRender: ({text, record}) => {
              if (text) {
                return (
                    <a-row style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                      <a-tooltip placement="top" title={<a-typography-text copyable style={{color: 'white'}}>{text}</a-typography-text>}>
                        <a-typography-text ellipsis>
                          {text}
                        </a-typography-text>
                      </a-tooltip>
                    </a-row>
                )
              } else {
                return "-"
              }
            }
          },
          {key: 'productName', title: '제품명', dataIndex: 'productName', align: 'center', width: '140px'},
          {
            key: 'productCode', title: '제품코드', dataIndex: 'productCode', align: 'center', width: '140px',
            customRender: ({text, record}) => {
              return (
                  <a-row style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <a-tooltip placement="top" title={text}>
                      <a-typography-text ellipsis>
                        {text}
                      </a-typography-text>
                    </a-tooltip>
                  </a-row>
              )
            }
          },
          {
            key: 'validationDate', dataIndex: 'validationDate', align: 'center', width: '100px',
            sorter: {
              compare: (a, b) => {
                return a.cardInfoList.find(item => item.status === SubscriptionCardStatusEnum.USE)?.validationDate - b.cardInfoList.find(item => item.status === SubscriptionCardStatusEnum.USE)?.validationDate
              },
            },
            title: () => {
              return (
                  <div style="display: flex; align-items: center; justify-content: center; gap: 4px">
                    유효기간
                    <a-tooltip title="카드 유효기간 3개월 미만 유효기간은 붉은색으로 나타납니다." trigger="click" onClick={(e) => e.stopPropagation()}>
                      <i class="fa-regular fa-info-circle" />
                    </a-tooltip>
                  </div>
              )
            },
            customRender: ({text, record}) => {
              let now = dayjs();
              let validationDate = dayjs(record.validationDate, "YYYY-MM");

              //   logging().exceptProd('cardInfoList==>', record.cardInfoList);
              //   logging().exceptProd('validationDate==>', `${validationDate}, ${now.diff(validationDate, 'month')}`);

              if (record.cardInfoList) {
                const currentCardInfo = record.cardInfoList.find(item => item.canUseCard)
                logging().exceptProd("currentCardInfo===>", JSON.stringify(currentCardInfo))
                if (now.diff(currentCardInfo?.validationDate, 'month') >= -2 && currentCardInfo?.validationDate !== '-') {
                  return (
                      <a-col>
                        <a-row type="flex" align="center"><span style={{color: 'red', fontWeight: 'bold'}}>{currentCardInfo?.validationDate}</span></a-row>
                        <a-row type="flex" align="center"><span style={{color: record.isOneTimePayment === 'Y' ? 'black' : 'red', fontSize: '12px'}}>{record.isOneTimePayment === 'Y' ? '-' : '카드 변경 요망'}</span></a-row>
                      </a-col>
                  )
                } else {
                  return <span>{currentCardInfo?.validationDate}</span>
                }
              } else {
                return <span>-</span>
              }

            }
          },
          {
            key: 'periodicPaymentDate', title: '결제예정일', dataIndex: 'periodicPaymentDate', align: 'center', width: '100px',
            customRender: ({text, record}) => {
              if (record.paymentInfos?.isOneTimePayment === 'Y') {
                return ('일시납')
              } else {
                return (
                    `매월 ${record.periodicPaymentDate} 일`
                )
              }
            }
          },
          {
            key: 'cardCompany', title: '결제카드', dataIndex: 'cardCompany', align: 'center', width: '110px',
            customRender: ({text, record}) => {
              const cardInfoList = record.cardInfoList
              const cardCompany = cardInfoList[0]?.cardCompany
              if (cardInfoList?.isOneTimePayment === 'Y') {
                return "-"
              } else {
                return (
                    <a-col style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column'
                    }}>
                      <a-row>
                        <span>{cardCompany}</span>
                      </a-row>
                      <a-row style={{marginTop: '2px'}}>
                        <a-button style={{height: '10px'}}
                                  disabled={record.isOneTimePayment === 'Y'}
                                  onClick={() => {
                                    this.modal.cardManagement.show = true
                                    this.selectedCards = cardInfoList
                                    sessionStorage.setItem("selectedSubscriptionId", record._id)
                                    this.selectedRowClientName = record.clientName
                                    this.selectedRowBarcode = record.productCode
                                  }}>카드관리
                        </a-button>
                      </a-row>
                    </a-col>
                )
              }
            }
          },
          {
            key: 'totalPeriodCount', title: '약정기간', dataIndex: 'totalPeriodCount', align: 'center', width: '90px',
            customRender: ({text, record}) => {
              //   console.log("===>", record.paymentInfos?.isOneTimePayment)
              if (record.paymentInfos?.isOneTimePayment === 'Y') {
                return ('일시납')
              } else {
                return (
                    `${record.currentPaymentPeriodCount}/${text} 개월`
                )
              }
            }
          },
          {
            key: 'subscriptionAmount',
            title: '정기결제금액',
            dataIndex: 'subscriptionAmount',
            align: 'center',
            width: '120px',
            customRender: ({text, record}) => {
              const subscriptionAmount = record?.subscriptionAmount?.toLocaleString();
              if (record.paymentInfos?.isOneTimePayment === 'Y') {
                return (
                    <div style={{display: 'flex', justifyContent: 'end'}}>
                      <a-typography-text>{subscriptionAmount}원</a-typography-text>
                    </div>
                )
              } else {
                return (
                    <div style={{display: 'flex', justifyContent: 'end'}}>
                      <a-typography-text>월 {subscriptionAmount}원</a-typography-text>
                    </div>
                )
              }
            }
          },
          {
            key: 'contractDate', title: '계약대수', dataIndex: 'contractDate', align: 'center', width: '80px',
            customRender: ({text, record}) => {
              const count = record.productCode?.split(",").length
              return (
                  `${count}대`
              )
            }
          },
          {
            key: 'contractDate', title: '계약일', dataIndex: 'contractDate', align: 'center', width: '100px',
            customRender: ({text, record}) => {
              if (record.contractInfo) return text;
              // 전자계약 메뉴가 없는 직원에게는 「계약서 생성」을 숨김(누르면 「권한 없음」으로 튕김 — 라우터와 같은 판정)
              if (!canOpen(ACTILINK_CONTRACT_PATH)) return '-';
              return <div>
                <button style={{marginLeft: "10px", padding: "6px", "border-radius": '5px'}}
                        onClick={() => this.$router.push(`${ACTILINK_CONTRACT_PATH}?name=ACTILINK+정기+렌탈서비스+약정서&group=영업`)}>계약서
                  생성
                </button>
              </div>;
            },
            sorter: {
              compare: (a, b) => {
                return a.contractDate - b.contractDate
              },
            },
          },
          {key: 'companyManager', title: '계약담당자', dataIndex: 'companyManager', align: 'center', width: '100px'},
          {
            key: 'subscriptionPaymentDate', title: '결제내역', dataIndex: 'subscriptionPaymentDate', align: 'center', width: '110px',
            customRender: ({text, record}) => {
              if (record.paymentInfos?.isOneTimePayment === 'Y') {
                return "-"
              } else {
                const existPaymentError = record?.payments?.length > 1 && record?.payments[1]?.tossError;
                let btnColor = existPaymentError ?
                    {backgroundColor: '#FFDEDB', color: '#E13E33'} : {backgroundColor: '', color: ''};
                return (
                    record.contractInfo ?
                        <a-col style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          flexDirection: 'column'
                        }}>
                          <a-row>
                            <span>{text}</span>
                          </a-row>
                          <a-row>
                            <a-button style={{
                              height: '10px',
                              color: btnColor?.color,
                              backgroundColor: btnColor?.backgroundColor
                            }}
                                      onClick={() => {
                                        this.modal.subscription.show = true
                                        this.selectedPayments = record.payments
                                      }}>보기
                            </a-button>
                          </a-row>
                        </a-col> : '-'
                )
              }
            }
          },
          {
            key: 'paymentAction', title: '결제하기', dataIndex: 'paymentAction', align: 'center', width: '110px',
            customRender: ({text, record}) => {
              if (record.paymentInfos?.isOneTimePayment === 'Y') {
                return "-"
              } else {
                const existPaymentError = record?.payments?.length > 1 && record?.payments[1]?.tossError;
                let btnColor
                if (existPaymentError) {
                  btnColor = { backgroundColor: '#FFDEDB', color: '#E13E33' };
                } else {
                  btnColor = { backgroundColor: '', color: '' };
                }
                return (
                    record.contractInfo ?
                        <a-col style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          flexDirection: 'column'
                        }}>
                          <a-row>
                            <span>{text}</span>
                          </a-row>
                          <a-row>
                            <a-button
                                style={{
                                  height: '10px',
                                  color: btnColor?.color,
                                  backgroundColor: btnColor?.backgroundColor
                                }}
                                onClick={(e) => this.uiHandler.paymentAction(record)}>결제하기
                            </a-button>
                          </a-row>
                        </a-col> : '-'
                )
              }
            }
          },
          {
            key: 'installmentAddress',
            title: '설치주소',
            dataIndex: 'installmentAddress',
            align: 'center',
            width: '280px',
            customRender: ({text, record}) => {
              return (
                  <a-tooltip placement="top" title={text}>
                    <a-typography-text ellipsis>
                      {text}
                    </a-typography-text>
                  </a-tooltip>
              )
            }
          },
          {
            key: 'view-contract', title: '계약서 보기', dataIndex: 'view-contract', align: 'center',
            customRender: ({text, record}) => {
              return (
                  record.contractInfo ?
                      <div onClick={() => this.uiHandler.fileDownload(record.contractId)}
                           style={{cursor: 'pointer', display: "flex", alignItems: 'left'}}>
                        <img src={require('@/assets/img/pdf-icon.svg')} alt="pdf logo"/>
                        <a-tooltip placement="top" title={record.contractInfo.title}>
                          <a-typography-text ellipsis style={{width: '90px'}}>
                            {record.contractInfo.title}
                          </a-typography-text>
                        </a-tooltip>
                      </div> : '-'
              );
            },
          }
        ]
      },
    }
  },
  methods: {
    ui() {
      return {
        paymentAction: async(subscription) => {
          const {_id, clientName, currentPaymentPeriodCount} = subscription
          logging().exceptProd("subscriptionId===>", _id);
          const isConfirm = await twoBtnDialog("결제하기", `${clientName}의 ${currentPaymentPeriodCount + 1} 회차 결제를 하시겠습니까?`)
          if (isConfirm) {
            await this.apiHandler.paymentAction(_id)
            const newSubscriptionInfo = await this.apiHandler.getSubscriptionById(_id)
            this.modal.subscription.show = true
            this.selectedPayments = newSubscriptionInfo.payments
          }
        },
        convertMonthAndYearText: (input) => {
          if (input < 12) return `${input}${this.$i18n.t('common_searchfilter_month')}`;
          return `${input / 12}${this.$i18n.t('common_searchfilter_year')}`;
        },
        init: async () => {
          await this.uiHandler.search()
        },
        handleTableChange: async (pagination, filters, sorter, extra) => {
            /*
                sorter 값
                validationDate,contractDate

                undefined: 그냥 정렬
                'ascend'
                'descend'
                어차피 백엔드 기본값이 validationDate / desc이므로 그걸 기본값으로
            */
           if(sorter.columnKey) {
                this.searchFilter.sort = {
                    parameter: sorter.columnKey || 'validationDate',
                    method: sorter.order || 'descend'
                }
           }
           console.log('clicked', sorter)
           await this.uiHandler.search();
        },
        search: async () => {
          this.dataLoading = true
          const params = {
            page: this.paginationData.currentPage,
            limit: this.paginationData.rowsPerPage
          }

          if (this.searchFilter.keyword.word) {
            if (this.searchFilter.keyword.option === '거래처명') {
              params['clientName'] = this.searchFilter.keyword.word
            }

            if (this.searchFilter.keyword.option === '제품코드') {
              params['productCode'] = this.searchFilter.keyword.word
            }
          }

          if (this.searchFilter.selectedDateFilter === 'all') {
            params["startContractDate"] = '20230101'
            params["endContractDate"] = '99991231'
          }
          if (this.searchFilter.selectedDateFilter === 3) {
            params["startContractDate"] = dayjs().subtract(3, 'month').format('YYYYMMDD')
            params["endContractDate"] = dayjs().format('YYYYMMDD')
          }
          if (this.searchFilter.selectedDateFilter === 12) {
            params["startContractDate"] = dayjs().subtract(12, 'month').format('YYYYMMDD')
            params["endContractDate"] = dayjs().format('YYYYMMDD')
          }
          if (this.searchFilter.selectedDateFilter === 'etc') {
            params["startContractDate"] = dayjs(this.dateRanges[0]?.valueOf()).format('YYYYMMDD')
            params["endContractDate"] = dayjs(this.dateRanges[1]?.valueOf()).format('YYYYMMDD')
          }
          if (this.searchFilter.startContractDate && this.searchFilter.endContractDate) {
            params["startContractDate"] = this.searchFilter.salesStartDate
            params["endContractDate"] = this.searchFilter.salesEndDate
          }

          if (this.searchFilter.status) {
            if (this.searchFilter.status !== "전체") {
              params["status"] = this.searchFilter.status
            }
          }

          if(this.searchFilter.sort.parameter && this.searchFilter.sort.method) {
            params['sort'] = this.searchFilter.sort;
          }

          await this.apiHandler.getSubscriptions(params, (response) => {
            this.calledApiTimes ++;
            this.subscription.totalDocs = response.data.totalDocs;
            this.paginationData.totalPages = response.data.totalPages;
            this.subscription.list = response.data.docs
            for (let i = 0; i < this.subscription.list.length; i++) {
              const item = this.subscription.list[i];
              item.index = this.subscription.totalDocs - (this.paginationData.currentPage - 1) * this.paginationData.rowsPerPage - i;
            }

          }, (error) => {

          }).finally(() => this.dataLoading = false)
        },
        getManagerInfo: (item) => {
        //   logging().exceptProd('managerinfo => ', item)
          const mobile = item.mobile;
          if (!item.email) return mobile;
          return `${mobile} / ${item.email}`;
        },
        fileDownload: async (contractId) => {
          await this.apiHandler.getContract(
              contractId,
              true,
              async (response) => {
                if (response.data?.file?.downloadUrl) {
                  window.open(response?.data?.file?.downloadUrl);
                }
              },
              (error) => {
                logging().exceptProd('getContracts fail==>', error);
                oneBtnDialog('다운로드 오류', '파일 다운로드에 실패했습니다.', false);
              }
          );
        },
        handleModal: {
          subscriptionDetail: {
            show: async () => {
              this.$store.commit('setIsLoading', true);
              this.modal.subscription.show = true
              this.$store.commit('setIsLoading', false);
            },
            close: async () => {
              await this.uiHandler.search();
              this.modal.subscription.show = false
            }
          },
          cardManagement: {
            show: async () => {
              this.$store.commit('setIsLoading', true);
              this.modal.cardManagement.show = true
              this.$store.commit('setIsLoading', false);
            },
            close: async () => {
              await this.uiHandler.search();
              this.modal.cardManagement.show = false
            },
            reload: async () => {
              await this.uiHandler.search().then(() => {
                console.log("cardInfo===>", this.subscription.list)
                this.selectedCards = this.subscription.list.find(s => {
                  return s._id === sessionStorage.getItem("selectedSubscriptionId")
                })?.cardInfoList
              });
            }
          }
        }
      }
    },
    api() {
      return subscriptionApi(this.$apiInstance, this.$store)
    }
  }
})
</script>
<style scoped lang="scss">
.search-filter-content {
  .mobile-wrap {
    display: flex;
    gap: 8px;
  }

  .mobile-no-wrap {
    display: flex;
  }
}

@media screen and (max-width: 767px) {
  .date-selector-container,
  .ant-picker.ant-picker-range {
    width: 100% !important;
  }
  .search-filter-content .date-filter-container-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .date-filter-container {
      flex-direction: row;
      border-radius: 0;
      border-bottom: 0;

      .date-filter-item {
        width: 50%;
        border-bottom: 0;
      }
    }
  }
  .container-fluid .row.justify-content-center {
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv {
    width: 100% !important;
  }
  .search-filter-title {
    margin-right: auto;
    width: auto;
    margin-left: 10px;
  }
  .search-filter-content .mobile-wrap {
    width: 100%;
  }
  .search-filter-content .search-select {
    width: 100px;
  }
  .search-filter-content .search-input-container {
    width: calc(100% - 100px);
    display: flex;
    justify-content: flex-start;

    input {
      width: 100%;
    }
  }
  .search-filter-content .date-filter-container {
    height: auto;
  }
  .search-filter-content .date-selector-container.custom {
    flex-direction: column;
    height: auto;
    align-items: center;
  }
  .search-filter-content .date-filter-container {
    flex-direction: column;
  }
  .search-filter-row {
    height: auto;
  }
  .search-filter-row,
  .search-filter-content {
    flex-direction: column;
    flex: none;
  }
  .card-header {
    margin: 0;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .search-filter-title {
    width: 100%;
    justify-content: flex-start;
    margin-left: 20px;
  }
  .table-with-search .table-info-filter {
    flex-direction: column;
    width: 100%;

    .total-div {
      margin-right: auto;
    }

    .search-container {
      width: 100%;
      flex-direction: row;

      .search-select {
        margin-right: auto;
      }

      .search-div {
        flex-direction: row;
        width: 100%;

        input {
          width: calc(100% - 80px) !important;
        }

        .search-btn {
          min-width: 80px;
        }
      }
    }
  }
  .search-filter-row {
    flex-direction: column;
    height: auto;

    &:nth-of-type(2) {
      .search-filter-content {
        flex-direction: column;
      }

      .search-filter-content {
        align-items: flex-start;
      }

      .date-selector-container.custom {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
      }
    }
  }
}
</style>
